import React from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import { withErrorBoundary } from 'components/ErrorBoundary';
import Card from './Card';

import * as styles from './GreenValues.module.scss';

function GreenValues({ title, subtitle, items }) {
  return (
    <Container id="our-values">
      <div className={styles.layout}>
        <Title>{title}</Title>
        <Subtitle size="lg">{subtitle}</Subtitle>
        <div className={styles.cardsWrapper}>
          {items.map(item => (
            <Card key={item.title} {...item} />
          ))}
        </div>
      </div>
    </Container>
  );
}

GreenValues.displayName = 'GreenValues';

export default withErrorBoundary(GreenValues);
